import React from 'react'
import { useMediaQuery } from 'react-responsive'
import Compte from '../../pages/Compte'
import CompteMobil from '../../pages/CompteMobil'

export default function CompteProvider() {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 992px)' })
  return isTabletOrMobile ? <CompteMobil /> : <Compte />
}
